import styled from 'styled-components';

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(17, 19, 20, 0.99);
`;

const StyledGradient = styled.div`
	position: absolute;
	width: 100%;
	height: 500px;
	left: 0;
	top: 0;
	background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
	opacity: 0.5;
`;

export { StyledBackground, StyledGradient };
